<template>
  <div class="what-we-do-area ptb-100">
    <div class="container">
      <div class="section-title text-center">
        <span class="sub-title">Nossas Especialidades</span>
        <h2>Fábrica de software com expertise de ponta</h2>
        <p>Do projeto sob medida aos produtos SaaS — entregamos sistemas que escalam com o seu negócio</p>
      </div>

      <div class="specialties-grid">
        <div
            v-for="(specialty, index) in specialties"
            :key="specialty.id"
            class="specialty-card"
            data-aos="fade-up"
            :data-aos-delay="index * 100"
        >
          <div class="card-header">
            <div class="specialty-icon" :class="specialty.colorClass">
              <i :class="specialty.icon"></i>
            </div>
            <div class="specialty-badge">
              {{ specialty.badge }}
            </div>
          </div>

          <div class="card-body">
            <h3>{{ specialty.title }}</h3>
            <p>{{ specialty.description }}</p>

            <div class="tech-stack">
              <span
                  v-for="(tech, idx) in specialty.technologies"
                  :key="idx"
                  class="tech-tag"
              >
                {{ tech }}
              </span>
            </div>

            <div class="specialty-stats">
              <div class="stat">
                <i class="ph-code"></i>
                <span>{{ specialty.projects }}+ Projetos</span>
              </div>
              <div class="stat">
                <i class="ph-clock"></i>
                <span>{{ specialty.experience }}</span>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <a :href="`https://wa.me/5554992302401?text=Quero saber mais sobre ${specialty.title}`"
               target="_blank"
               class="specialty-link"
               rel="noopener noreferrer">
              Saber Mais
              <i class="ph-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Diferencial -->
      <div class="differentials-section" data-aos="fade-up">
        <h3>Por que somos especialistas?</h3>
        <div class="differentials-grid">
          <div class="differential-item">
            <i class="ph-graduation-cap"></i>
            <div>
              <strong>Equipe Certificada</strong>
              <span>Desenvolvedores com certificações internacionais</span>
            </div>
          </div>
          <div class="differential-item">
            <i class="ph-trophy"></i>
            <div>
              <strong>Prêmios & Reconhecimento</strong>
              <span>Projetos premiados no mercado</span>
            </div>
          </div>
          <div class="differential-item">
            <i class="ph-arrows-clockwise"></i>
            <div>
              <strong>Atualização Constante</strong>
              <span>Sempre nas últimas tecnologias</span>
            </div>
          </div>
          <div class="differential-item">
            <i class="ph-handshake"></i>
            <div>
              <strong>Parceiros Oficiais</strong>
              <span>Parcerias com grandes empresas de tech</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Background Elements -->
    <div class="bg-decoration">
      <div class="decoration-shape shape-1"></div>
      <div class="decoration-shape shape-2"></div>
      <div class="decoration-shape shape-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatWeDo',
  data() {
    return {
      specialties: [
        {
          id: 1,
          icon: 'ph-factory',
          colorClass: 'purple',
          title: 'Fábrica de Software',
          badge: 'Projetos',
          description: 'Desenvolvimento ponta a ponta: discovery, arquitetura, implementação, testes e evolução contínua do produto.',
          technologies: ['Vue.js', 'React', 'Laravel', 'Node.js'],
          projects: 120,
          experience: '5+ anos'
        },
        {
          id: 2,
          icon: 'ph-squares-four',
          colorClass: 'green',
          title: 'ERP & Gestão',
          badge: 'Sistemas',
          description: 'ERPs completos e sistemas verticais — Business One, escolar, nutrição e soluções sob medida para o seu segmento.',
          technologies: ['Multi-tenant', 'SaaS', 'API-first'],
          projects: 40,
          experience: '5+ anos'
        },
        {
          id: 3,
          icon: 'ph-device-mobile',
          colorClass: 'blue',
          title: 'Apps Mobile',
          badge: 'iOS & Android',
          description: 'Apps nativos e híbridos para iOS e Android, com design moderno e integração aos seus sistemas.',
          technologies: ['React Native', 'Flutter', 'Expo'],
          projects: 60,
          experience: '3+ anos'
        },
        {
          id: 4,
          icon: 'ph-robot',
          colorClass: 'orange',
          title: 'Automação & IA',
          badge: 'Processos',
          description: 'Automações, workflows e assistentes de IA para reduzir custo operacional e acelerar a operação.',
          technologies: ['Python', 'APIs', 'RPA', 'AI'],
          projects: 95,
          experience: '5+ anos'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* ===== AREA BASE ===== */
.what-we-do-area {
  background: linear-gradient(180deg, #ffffff 0%, #f9f9f9 100%);
  position: relative;
  overflow: hidden;
}

/* ===== GRID DE ESPECIALIDADES ===== */
.specialties-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin: 60px 0 80px;
}

/* ===== CARD ===== */
.specialty-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
}

.specialty-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
  border-color: #6D5DFC;
}

/* ===== CARD HEADER ===== */
.card-header {
  padding: 35px 30px 25px;
  position: relative;
}

.specialty-icon {
  width: 90px;
  height: 90px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: all 0.4s ease;
}

.specialty-card:hover .specialty-icon {
  transform: scale(1.1) rotate(-5deg);
}

.specialty-icon i {
  font-size: 45px;
  color: white;
}

.specialty-icon.purple {
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
}

.specialty-icon.green {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
}

.specialty-icon.blue {
  background: linear-gradient(135deg, #4361EE 0%, #3B82F6 100%);
}

.specialty-icon.orange {
  background: linear-gradient(135deg, #F59E0B 0%, #EF4444 100%);
}

.specialty-badge {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(109, 93, 252, 0.1);
  border: 1px solid rgba(109, 93, 252, 0.3);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  color: #6D5DFC;
  text-transform: uppercase;
}

/* ===== CARD BODY ===== */
.card-body {
  padding: 0 30px 25px;
  flex: 1;
}

.card-body h3 {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 15px;
  transition: color 0.3s ease;
}

.specialty-card:hover .card-body h3 {
  color: #6D5DFC;
}

.card-body p {
  font-size: 15px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
}

/* ===== TECH STACK ===== */
.tech-stack {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.tech-tag {
  display: inline-block;
  padding: 5px 12px;
  background: #f5f5f5;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #444;
  transition: all 0.3s ease;
}

.specialty-card:hover .tech-tag {
  background: rgba(109, 93, 252, 0.1);
  color: #6D5DFC;
}

/* ===== STATS ===== */
.specialty-stats {
  display: flex;
  gap: 20px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.stat {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
}

.stat i {
  font-size: 18px;
  color: #6D5DFC;
}

/* ===== CARD FOOTER ===== */
.card-footer {
  padding: 20px 30px;
  background: #f9f9f9;
  border-top: 1px solid #eee;
}

.specialty-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #6D5DFC;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.specialty-link:hover {
  gap: 12px;
  color: #4361EE;
}

.specialty-link i {
  font-size: 16px;
  transition: transform 0.3s ease;
}

.specialty-link:hover i {
  transform: translateX(4px);
}

/* ===== DIFFERENTIALS ===== */
.differentials-section {
  background: linear-gradient(135deg, rgba(109, 93, 252, 0.05) 0%, rgba(67, 97, 238, 0.05) 100%);
  padding: 50px;
  border-radius: 20px;
  border: 2px solid rgba(109, 93, 252, 0.1);
}

.differentials-section h3 {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin-bottom: 40px;
}

.differentials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.differential-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  background: white;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.differential-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(109, 93, 252, 0.15);
}

.differential-item i {
  font-size: 32px;
  color: #6D5DFC;
  flex-shrink: 0;
  margin-top: 5px;
}

.differential-item div {
  display: flex;
  flex-direction: column;
}

.differential-item strong {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 5px;
  display: block;
}

.differential-item span {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

/* ===== BACKGROUND DECORATION ===== */
.bg-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.decoration-shape {
  position: absolute;
  background: radial-gradient(circle, rgba(109, 93, 252, 0.08) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(60px);
}

.shape-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  right: -100px;
}

.shape-2 {
  width: 350px;
  height: 350px;
  bottom: 10%;
  left: -100px;
}

.shape-3 {
  width: 300px;
  height: 300px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ===== RESPONSIVE ===== */
@media (max-width: 991px) {
  .specialties-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .differentials-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .specialties-grid {
    grid-template-columns: 1fr;
  }

  .differentials-section {
    padding: 30px 20px;
  }

  .differentials-grid {
    grid-template-columns: 1fr;
  }

  .card-body h3 {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .specialty-icon {
    width: 70px;
    height: 70px;
  }

  .specialty-icon i {
    font-size: 35px;
  }

  .card-header,
  .card-body,
  .card-footer {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>